import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'

import { PRODUCT_TYPES } from 'constants/productTypes'
import { HERO_STARS } from 'constants/stars'
import ROUTES from 'constants/routes'
import bannerAnimation from 'assets/animations/banner.json'
import LottiePlayer from 'components/Shared/LottiePlayer'
import Star from 'components/Landing/Star'
import Product from 'components/Landing/Product'
import LandingButton from './LandingButton'

function Hero() {
  const { t } = useTranslation()

  return (
    <div className="hero">
      <div className="flex-column">
        <div className="hero__title">{t('landing.hero.title')}</div>
        <LandingButton
          to={ROUTES.APP_URL_LOGIN}
          text={t('landing.hero.play_now')}
          variant="desktop"
        />
      </div>
      <div className="hero__animation">
        {HERO_STARS.map((star) => (
          <Star
            key={`hero-star-${star.position}`}
            className={`hero__star hero__star--${star.position}`}
            reverse={star.reverse}
          />
        ))}
        {PRODUCT_TYPES.map((productName, index) => (
          <Product
            key={`hero-product-${productName}`}
            className={`hero__product hero__product--${productName}`}
            imageClassName="hero__product-image"
            name={productName}
            reverse={index % 2 === 0}
          />
        ))}
        <LottiePlayer animationData={bannerAnimation} className="hero__banner" />
      </div>
      <LandingButton to={ROUTES.APP_URL_LOGIN} text={t('landing.hero.play_now')} variant="mobile" />
    </div>
  )
}

export default memo(Hero)
